import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'

import api from '@/lib/api'

interface UpdateParams {
  senha: string
  id_product: string
}

export function useUpdatePasswordProduct() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()

  return useMutation({
    mutationFn: async ({ senha, id_product }: UpdateParams) => {
      if (!user || !token) throw new Error('Usuário não autenticado')

      const body = {
        senha: senha || ''
      }

      const response = await api.post(`/products/senha-produto/${id_product}`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data
      } else {
        throw new Error('Erro ao atualizar senha do produto')
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['productSenha'] })
    }
  })
}
